import { type FC } from 'react';

import styles from './PdpMobileSectionDivider.scss';

export const PdpMobileSectionDivider: FC = () => {
    return <div className={styles.sectionDivider} />;
};
